export default __webpack_public_path__ + "static/deep-dive-mobile-2dc28c15cf66e33a1a13b8dddcf05e28.webp";